import React from 'react'
import Translation from '../../Translation/cont/Translation'
import Button from '../../general/Button'
import { AdvertisementListNoticeMulticinema, AdvertisementListNoticeSingleCinema, AdvertisementTextSpan } from './AdvertisementComponents'
import AdvertisementListItem from './AdvertisementListItem'


const AdvertisementList = ({data, maxItems, weischerItems, titleTransId, buttonTransId, isSingleCinema, cliCinemasIdList, cliCinemas, addItem, editItem, deleteItem}) => {
    const { order, items, itemType }  = data
    const activeIds = order.filter(id => items[id].active)
    const trueMaxItems = false === weischerItems ? maxItems : maxItems - weischerItems
    
    let orderCanBeDisplayed = []
    let orderCanNotBeDisplayed = []

    if(isSingleCinema && false !== trueMaxItems && order.length > trueMaxItems) {
        const l = activeIds.length - trueMaxItems

        if(l > 0) {
            orderCanBeDisplayed = activeIds.slice(0, trueMaxItems)
        } else if(l === 0) {
            orderCanBeDisplayed = activeIds
        } else {
            orderCanBeDisplayed = [...activeIds, ...order.filter(id => !activeIds.includes(id)).slice(0, Math.abs(l))]
        }

        orderCanNotBeDisplayed = order.filter(id => !orderCanBeDisplayed.includes(id))
    } else {
        orderCanBeDisplayed = order
        orderCanNotBeDisplayed = []
    }

    return (
        <div  className="advertisement-list">
            <p className="advertisement-list-title title-large-light"><Translation id={titleTransId}/></p>

            {order.length > 0 && <div className="advertisement-list-container">
                {!isSingleCinema && <AdvertisementListNoticeMulticinema
                    maxItems={maxItems}
                    trueMaxItems={trueMaxItems}
                />}

                <div className="advertisement-list-head">
                    <AdvertisementTextSpan>
                        <Translation id="advertisement_name"/>
                    </AdvertisementTextSpan>

                    <AdvertisementTextSpan>
                        <Translation id="advertisement_start"/>
                    </AdvertisementTextSpan>

                    <AdvertisementTextSpan>
                        <Translation id="advertisement_end"/>
                    </AdvertisementTextSpan>

                    <AdvertisementTextSpan extraClass="center">
                        <Translation id="advertisement_link"/>
                    </AdvertisementTextSpan>

                    <AdvertisementTextSpan extraClass="center">
                        <Translation id="advertisement_active"/>
                    </AdvertisementTextSpan>
                </div>

                <ul className="advertisement-list-body">
                    {orderCanBeDisplayed.map((itemId, index) => <AdvertisementListItem
                        key={itemId}
                        index={index}
                        item={items[itemId]}
                        isSingleCinema={isSingleCinema}
                        cliCinemasIdList={cliCinemasIdList}
                        cliCinemas={cliCinemas}
                        editItem={editItem}
                        deleteItem={deleteItem}
                    />)}
                </ul>

                {orderCanNotBeDisplayed.length > 0  && <>
                    <AdvertisementListNoticeSingleCinema
                        maxItems={maxItems}
                        trueMaxItems={trueMaxItems}
                    />

                    <ul className="advertisement-list-body">
                        {orderCanNotBeDisplayed.map((itemId, index) => <AdvertisementListItem
                            key={itemId}
                            index={index}
                            item={items[itemId]}
                            isSingleCinema={isSingleCinema}
                            cliCinemasIdList={cliCinemasIdList}
                            cliCinemas={cliCinemas}
                            editItem={editItem}
                            deleteItem={deleteItem}
                        />)}
                    </ul>
                </>}
            </div>}

            <Button
                className="advertisement-button-add"
                transId={buttonTransId}
                hideText={false}
                onClick={()=> addItem(itemType)}
            />
        </div>
    )
}

export default AdvertisementList